import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import {
  getMetricsForDeviceType,
  METRIC_CATEGORIES,
  METRIC_LABELS,
} from "../../../constants/metricCategories";

interface MetricSelectorProps {
  value: string | null;
  onChange: (metricKey: string | null) => void;
  deviceType: "fitbit" | "healthkit" | "both" | "none";
  disabled?: boolean;
}

const MetricSelector: React.FC<MetricSelectorProps> = ({
  value,
  onChange,
  deviceType,
  disabled = false,
}) => {
  const availableMetrics = React.useMemo(
    () => new Set(getMetricsForDeviceType(deviceType)),
    [deviceType],
  );

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value || null);
  };

  return (
    <FormControl fullWidth disabled={disabled || deviceType === "none"}>
      <InputLabel id="metric-selector-label">Select Metric</InputLabel>
      <Select
        labelId="metric-selector-label"
        id="metric-selector"
        value={value || ""}
        label="Select Metric"
        onChange={handleChange}
      >
        {Object.entries(METRIC_CATEGORIES).flatMap(([category, metrics]) => {
          const filteredMetrics = (metrics as readonly string[]).filter(
            (metric) => availableMetrics.has(metric),
          );
          if (filteredMetrics.length === 0) return [];

          return [
            <MenuItem disabled key={`header-${category}`} value="">
              <strong>{category}</strong>
            </MenuItem>,
            ...filteredMetrics.map((metric) => (
              <MenuItem key={metric} value={metric} sx={{ pl: 4 }}>
                {METRIC_LABELS[metric] || metric}
              </MenuItem>
            )),
          ];
        })}
      </Select>
    </FormControl>
  );
};

export default MetricSelector;
